// @flow

// Action Types
const actionPrefix: string = '@@datatable/comments/'
export const SELECT_RECORDS = `${actionPrefix}SELECT_RECORDS`
export const UPDATE_FILTER = `${actionPrefix}UPDATE_FILTER`

// Datatable
export const DATATABLE_NAME = 'Comments'

// Record attrs
export const ATTR_COMMENT_ID = 'id'
export const ATTR_CROP = 'crop'
export const ATTR_YIELD_TARGET = 'yield_target'
export const ATTR_FIELD = 'field'
export const ATTR_DATE_CREATED = 'date_created'
export const ATTR_RECOMMENDED_RATES = 'recommended_rates'
export const ATTR_JOB_ID = 'job_id'
export const ATTR_HAS_RECOMMENDED_RATES = 'hasRecommendedRates'
